// ════════════════════════════════════════════════════════════════════
// dateUtils — safe formatting for YYYY-MM-DD appointment dates.
//
// THE BUG THIS GUARDS AGAINST:
//   appointment.date is stored as "2026-06-03" (date-only, no time).
//   `new Date("2026-06-03")` parses as UTC midnight, which in NY (UTC-4)
//   becomes "Tue Jun 2 8 PM" — and `toLocaleDateString` then formats it
//   as "Tuesday, June 2". Confirmation emails went out with the WRONG
//   day. This module always renders the calendar date as written.
// ════════════════════════════════════════════════════════════════════

/**
 * Format a YYYY-MM-DD appointment date string for display.
 * Falls back to native Date parsing if the input is a full timestamp.
 */
export function fmtAppointmentDate(dateStr, opts = { weekday: "long", month: "long", day: "numeric", year: "numeric" }) {
  if (!dateStr) return "";
  const m = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) {
    // Looks like a full timestamp (has time, ISO offset, etc.) — let
    // Date parse it directly since timestamps carry their own zone.
    try { return new Date(dateStr).toLocaleDateString("en-US", opts); }
    catch (_) { return String(dateStr); }
  }
  const [, y, mm, dd] = m;
  // Force noon LOCAL — keeps the same calendar date in any zone.
  const safe = new Date(Number(y), Number(mm) - 1, Number(dd), 12, 0, 0);
  return safe.toLocaleDateString("en-US", opts);
}

/** Convert a Date object to local YYYY-MM-DD without UTC shift. */
export function toLocalDateStr(d) {
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
